exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".legend {\n  display: flex;\n  flex-direction: column;\n}\n\n.legend .legend__rows {\n  display: flex;\n  flex-direction: column;\n  padding: 2rem 0;\n}\n\n.legend .legend-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.6rem 0;\n}\n\n.legend .legend-row .legend-row__color {\n  width: 2rem;\n  height: 1rem;\n  margin-left: 0.5rem;\n  margin-right: 0.3rem;\n  border-radius: 1rem;\n}\n\n.legend .legend-row .legend-row__value {\n  flex: 1;\n  text-align: right;\n  font-size: 3rem;\n}\n\n.legend .legend-row .legend-row__name {\n  flex: 1;\n  font-size: 3rem;\n}\n\n", ""]);

// exports
